/**
 * 父子窗口 postMessage 通信协议：子应用请求回投 access_token
 * URL 拼接通道保持不变，本协议为双通道并存
 */
export const PROTOCOL = {
  // 子端 → 父端：请求回投 access_token，父端按它过滤
  REQ: 'get_access_token',
  // 父端 → 子端：回投 access_token，子端按它过滤
  RES: 'access_token',
};
